import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function RoleGuard({ children, allowedRoles = [], fallbackComponent = null }) {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // If not authenticated, this should be handled by ProtectedRoute
  if (!isAuthenticated || !user) {
    return null;
  }

  // Get user role from user object (assuming role is stored in user.role)
  const userRole = user.role || 'admin'; // default to admin for backward compatibility

  // Check if user has required role
  const hasRequiredRole = allowedRoles.length === 0 || allowedRoles.includes(userRole);

  if (!hasRequiredRole) {
    if (fallbackComponent) {
      return fallbackComponent;
    }

    return (
      <Box 
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '400px',
          textAlign: 'center',
          p: 3
        }}
      >
        <Typography variant="h5" color="error" gutterBottom>
          Access Denied
        </Typography>
        <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
          You don't have the required permissions to access this resource.
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
          Required role(s): {allowedRoles.join(', ')}
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
          Your role: {userRole}
        </Typography>
        <Button 
          variant="outlined" 
          onClick={() => navigate('/dashboard')}
        >
          Go to Dashboard
        </Button>
      </Box>
    );
  }

  return children;
}

export default RoleGuard;